import { Component, computed, input, InputSignal, Signal, inject } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { WatchListSettingsInterface } from '@shared/components/trading/widgets/watch-list-widget/core/interfaces/watch-list-settings.interface'
import { DropdownColumnsActionsComponent } from '@shared/components/trading/widgets/common/dropdown-columns-actions/dropdown-columns-actions.component'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'
import { ColumnInterface } from '@shared/interfaces/column.interface'
import { WatchListColumnsEnum } from '@shared/components/trading/widgets/watch-list-widget/core/enums/watch-list-columns.enum'

@Component({
	selector: 'app-watch-list-widget-actions',
	templateUrl: './watch-list-widget-actions.component.html',
	styleUrl: './watch-list-widget-actions.component.scss',
	imports: [DropdownColumnsActionsComponent],
})
export class WatchListWidgetActionsComponent {
	public widget: InputSignal<WidgetInterface<WatchListSettingsInterface> | null> =
		input<WidgetInterface<WatchListSettingsInterface> | null>(null)

	public columns: Signal<ColumnInterface<WatchListColumnsEnum>[]> = computed<ColumnInterface<WatchListColumnsEnum>[]>(
		(): ColumnInterface<WatchListColumnsEnum>[] => this.widget()?.settings?.columns ?? [],
	)

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)

	protected onChangeColumns(columns: ColumnInterface<WatchListColumnsEnum>[]): void {
		const widget: WidgetInterface<WatchListSettingsInterface> | null = this.widget()
		if (!widget) return

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				columns,
			},
		})
	}
}
